package com.milta.core.localization.translations.it

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Carica un file di consegne e assegnalo a un autista",
    stepImport = "Importa",
    stepVerifyAssign = "Verifica e assegna",
    stepValidateSend = "Convalida e invia i giri",
    dropzoneTitle = "Trascina e rilascia il tuo file di consegne",
    dropzoneOrPrefix = "oppure",
    browseFilesLink = "sfoglia i tuoi file",
    browseFilesButton = "Sfoglia i file",
    constraintsLabel = "Excel (.xlsx, .xls), CSV o PDF · max 500 fermate · 10 MB",
    expectedColumnsEyebrow = "Colonne previste nel file",
    columnRecipientName = "Nome del destinatario",
    columnAddress = "Indirizzo completo",
    columnDeadline = "Orario limite",
    columnPhone = "Telefono",
    requiredPillLabel = "Obbligatorio",
    optionalPillLabel = "Facoltativo",
    analysingLabel = "Analisi in corso…",
    analysingCanLeaveLabel = "File inviato. Puoi lasciare questa pagina, l'analisi continua.",
    importOnMobileMessage = "È in corso un'importazione nell'app mobile (%s). Completala nell'app per importare un altro file qui.",
    invalidFileTitle = "File illeggibile o formato non supportato",
    invalidFileMessage = "«%s» non è stato possibile analizzarlo. Utilizza un file Excel (.xlsx, .xls), CSV o PDF conforme alle colonne previste.",
    chooseAnotherFileButton = "Scegli un altro file",
    extractionFailedTitle = "Impossibile estrarre le consegne",
    extractionFailedMessage = "Il file «%s» è stato letto ma non è stata trovata alcuna riga utilizzabile. Verifica che contenga le colonne previste.",
    serviceUnavailableTitle = "Servizio di analisi temporaneamente non disponibile",
    serviceUnavailableMessage = "Al momento non riusciamo ad analizzare il tuo file. Il tuo file è conservato: riprova tra qualche istante.",
    retryButton = "Riprova",
    fileImportedStatus = "File importato",
    stopsDetectedSuffix = "fermate rilevate",
    replaceFileLink = "↺ Sostituisci",
    assignToEyebrow = "Assegna a",
    selectDriverRequiredError = "Seleziona almeno un autista prima di inviare il giro.",
    selectedDriversCountSuffix = "autisti selezionati",
    optimizeRouteButton = "Ottimizza il percorso",
    tableCaptionLead = "Verifica e correggi le fermate prima di inviare",
    tableCaptionHint = "Clicca sulla matita per correggere una riga",
    locationBlockedHint = "Ogni riga deve avere un indirizzo localizzato (GPS) prima dell'invio agli autisti. Correggi le righe interessate (✎) o riprova la geocodifica.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Nome destinatario",
    columnHeaderAddress = "Indirizzo",
    columnHeaderPhone = "Telefono",
    columnHeaderDeadline = "Orario limite",
    columnHeaderPackageCount = "Colli",
    dashPlaceholder = "—",
    discardDraftButton = "Annulla importazione",
    discardDraftDialogTitle = "Annullare questa importazione?",
    discardDraftDialogMessage = "Le consegne già importate andranno perse definitivamente. Questa azione non può essere annullata.",
    discardDraftConfirmButton = "Sì, annulla importazione",
    freeFormatBanner = "Rilevato formato libero — le colonne non sono state riconosciute automaticamente, verifica ogni riga prima di inviare.",
    incompleteStopsBannerSuffix = "fermate incomplete — nome o indirizzo mancante, da correggere prima dell'invio.",
    rowFlagMissingName = "⚠ nome mancante",
    rowFlagMissingAddress = "⚠ indirizzo mancante",
    alreadyDispatchedBanner = "Questo giro è già stato inviato a un autista — aggiorna la pagina per ripartire con una nuova importazione.",
    routeNotFoundError = "Giro non trovato. Aggiorna la pagina e riprova.",
    validationErrorGeneric = "Controlla le informazioni inserite.",
    submitServerError = "Si è verificato un errore. Riprova.",
    submitOptimizationUnavailableError = "Servizio di ottimizzazione temporaneamente non disponibile. Il giro non è stato creato — riprova tra qualche istante.",
    sendWithoutOptimizationButton = "Invia senza ottimizzazione",
    dispatchSuccessMessage = "Giro inviato con successo a %s",
    dispatchSuccessBatchMessage = "Giri inviati con successo a %d autisti",
    tooManyStopsError = "Questo file contiene più di 500 consegne. Dividilo prima di importarlo.",
    resultHeaderMiddle = "consegne suddivise tra",
    resultDriverSingularSuffix = "autista",
    resultDriverPluralSuffix = "autisti",
    resultDistanceLabel = "Distanza",
    resultDurationLabel = "Durata stimata",
    resultMetricNotCalculatedLabel = "Non calcolata",
    resultStopsChipSuffix = "fermate",
    resultMoreStopsTemplate = "+ %d altre fermate",
    resultStopsLoadError = "Impossibile caricare le fermate di questo giro.",
    resultDispatchButton = "Convalida e invia i giri",
)
